// GENERATED by scripts/gen-reject-codes.mjs - do not edit by hand; re-run it.
//
// Sources:
//   - 2290_Business_Rules_Publication_2026v1.1.csv (IRS 2290 Business Rules Publication) - irsText,
//     category, severity; only rules with status "Active" are included.
//   - IrsRuleClassificationRegistry.java (form2290-api) - title, explanation, howToFix,
//     and whether the filer can fix it (fixable) or support has to (not fixable).
//
// Generated 2026-10-07: 101 active rules, 34 filer-fixable.

export const REJECT_CODES = [
  {
    "code": "F2290-002-01",
    "codeSlug": "f2290-002-01",
    "irsText": "If Form 2290, Part I, Line 3 has a non-zero value, then 'Taxable Gross Weight Increase Worksheet' [TGWIncreaseWorksheet] must be attached.",
    "category": "Missing Document",
    "severity": "Reject",
    "fixable": true,
    "title": "Weight-increase worksheet is missing",
    "explanation": "Line 3 (tax increase from a weight change) has a value, but the required Taxable Gross Weight Increase Worksheet wasn't attached.",
    "section": "AMENDED_RETURN",
    "howToFix": [
      "Open the return and go to the Amended return step.",
      "Confirm the amendment reason and the weight-increase worksheet details.",
      "Save.",
      "Return to this filing, review it, and submit again."
    ]
  },
  {
    "code": "F2290-003-01",
    "codeSlug": "f2290-003-01",
    "irsText": "If Form 2290, Part I, Line 3 has a non-zero value, then Form 2290, checkbox \"Amended Return\" must be checked.",
    "category": "Missing Data",
    "severity": "Reject",
    "fixable": true,
    "title": "Amended Return checkbox should be checked",
    "explanation": "Line 3 has a value, which means this must be filed as an Amended Return, but that checkbox isn't checked.",
    "section": "AMENDED_RETURN",
    "howToFix": [
      "Open the return and go to the Amended return step.",
      "Confirm the amendment reason and the weight-increase worksheet details.",
      "Save.",
      "Return to this filing, review it, and submit again."
    ]
  },
  {
    "code": "F2290-004-01",
    "codeSlug": "f2290-004-01",
    "irsText": "If Form 2290, Part I, Line 5 has a non-zero value, then Form 2290, Part I, Line 4 must not be less than Form 2290, Part I, Line 5.",
    "category": "Incorrect Data",
    "severity": "Reject",
    "fixable": true,
    "title": "Credit amount can't exceed the tax due",
    "explanation": "Line 5 (credits) has a value, but it's greater than Line 4 (total tax) - a credit can't exceed the tax it's offsetting.",
    "section": "CREDITS",
    "howToFix": [
      "Open the return and go to the Credits step.",
      "Review the credit amount and the VIN(s) it's claimed against.",
      "Correct or remove the affected credit.",
      "Return to this filing, review it, and submit again."
    ]
  },
  {
    "code": "F2290-005-01",
    "codeSlug": "f2290-005-01",
    "irsText": "If Form 2290, Part I, Line 5 has a non-zero value and Line 5 is less than or equal to Line 4, then Form 2290, Part I, Line 5 \"Credits Amount Statement\" [CreditsAmountStatement] must be attached.",
    "category": "Missing Document",
    "severity": "Reject",
    "fixable": true,
    "title": "Credits amount statement is missing",
    "explanation": "Line 5 has a value, but the required statement explaining the credit (with its VIN) wasn't attached.",
    "section": "CREDITS",
    "howToFix": [
      "Open the return and go to the Credits step.",
      "Review the credit amount and the VIN(s) it's claimed against.",
      "Correct or remove the affected credit.",
      "Return to this filing, review it, and submit again."
    ]
  },
  {
    "code": "F2290-006",
    "codeSlug": "f2290-006",
    "irsText": "Form 2290, Part I, Line 5, attachment \"Credits Amount Statement\" [ CreditsAmountStatement], Vehicle Identification Numbers provided must not contain duplicate values.",
    "category": "Incorrect Data",
    "severity": "Reject",
    "fixable": true,
    "title": "Duplicate VIN in the credits statement",
    "explanation": "The same VIN appears more than once in the Line 5 credits statement.",
    "section": "CREDITS",
    "howToFix": [
      "Open the return and go to the Credits step.",
      "Review the credit amount and the VIN(s) it's claimed against.",
      "Correct or remove the affected credit.",
      "Return to this filing, review it, and submit again."
    ]
  },
  {
    "code": "F2290-007-01",
    "codeSlug": "f2290-007-01",
    "irsText": "Form 2290, Line 6 must equal Line 4 minus (-) Line 5.",
    "category": "Math Error",
    "severity": "Reject",
    "fixable": false,
    "title": "Balance due doesn't match",
    "explanation": "Line 6 doesn't equal Line 4 minus Line 5. This is a computed figure."
  },
  {
    "code": "F2290-008-01",
    "codeSlug": "f2290-008-01",
    "irsText": "If Form 2290, Line 7, checkbox \"5,000 miles or less\" OR \"7,500 mile or less for agricultural vehicles\" is checked, then \"Tax Computation\" \"Category \" \"W\" column (3) (a) or (b) must have a positive value.",
    "category": "Missing Data",
    "severity": "Reject",
    "fixable": true,
    "title": "Mileage-limit vehicles need a Category W entry",
    "explanation": "A mileage-limit box (5,000 miles or less / 7,500 for agricultural) is checked, but no Category W (suspended) vehicle was entered.",
    "section": "TRUCKS",
    "howToFix": [
      "Open the return and go to the Trucks step.",
      "Review the flagged VIN(s) and vehicle details.",
      "Correct or remove the affected vehicle.",
      "Return to this filing, review it, and submit again."
    ]
  },
  {
    "code": "F2290-009-01",
    "codeSlug": "f2290-009-01",
    "irsText": "If Form 2290, Part II, Line 8a checkbox is checked, then Line 8b \"Suspended VIN Statement\" [SuspendedVINStatement] must be attached.",
    "category": "Missing Data",
    "severity": "Reject",
    "fixable": true,
    "title": "Suspended-vehicle statement is missing",
    "explanation": "Line 8a (mileage exceeded) is checked, but the required list of suspended-vehicle VINs (Line 8b) wasn't provided.",
    "section": "PRIOR_YEAR",
    "howToFix": [
      "Open the return and go to the Prior year step.",
      "Review the suspended-vehicle VIN(s) you listed.",
      "Remove any duplicate, or correct a VIN that also appears on Schedule 1.",
      "Return to this filing, review it, and submit again."
    ]
  },
  {
    "code": "F2290-010-01",
    "codeSlug": "f2290-010-01",
    "irsText": "If Form 2290, Part II, Line 8b, \"Suspended VIN Statement\" [SuspendedVINStatement] is attached, then Line 8a checkbox must be checked.",
    "category": "Missing Data",
    "severity": "Reject",
    "fixable": true,
    "title": "Line 8a checkbox should be checked",
    "explanation": "Suspended-vehicle VINs were listed on Line 8b, but the Line 8a checkbox isn't checked.",
    "section": "PRIOR_YEAR",
    "howToFix": [
      "Open the return and go to the Prior year step.",
      "Review the suspended-vehicle VIN(s) you listed.",
      "Remove any duplicate, or correct a VIN that also appears on Schedule 1.",
      "Return to this filing, review it, and submit again."
    ]
  },
  {
    "code": "F2290-011-01",
    "codeSlug": "f2290-011-01",
    "irsText": "If Form 2290, Part II, Line 8b \"Suspended VIN Statement\" [SuspendedVINStatement] is attached, then Vehicle Identification Numbers provided in the statement must not contain duplicate values.",
    "category": "Incorrect Data",
    "severity": "Reject",
    "fixable": true,
    "title": "Duplicate VIN in the suspended-vehicle list",
    "explanation": "The same VIN appears more than once in the Line 8b suspended-vehicle statement.",
    "section": "PRIOR_YEAR",
    "howToFix": [
      "Open the return and go to the Prior year step.",
      "Review the suspended-vehicle VIN(s) you listed.",
      "Remove any duplicate, or correct a VIN that also appears on Schedule 1.",
      "Return to this filing, review it, and submit again."
    ]
  },
  {
    "code": "F2290-012-01",
    "codeSlug": "f2290-012-01",
    "irsText": "If Form 2290, Part II, Line 9 \"Statement in Support of Suspension\" [StatementInSupportOfSuspension] is attached, then Vehicle Identification Numbers provided in the statement must not contain duplicate values.",
    "category": "Incorrect Data",
    "severity": "Reject",
    "fixable": true,
    "title": "Duplicate VIN in the sold/transferred statement",
    "explanation": "The same VIN appears more than once in the Line 9 (sold or transferred suspended vehicle) statement.",
    "section": "PRIOR_YEAR",
    "howToFix": [
      "Open the return and go to the Prior year step.",
      "Review the suspended-vehicle VIN(s) you listed.",
      "Remove any duplicate, or correct a VIN that also appears on Schedule 1.",
      "Return to this filing, review it, and submit again."
    ]
  },
  {
    "code": "F2290-013-01",
    "codeSlug": "f2290-013-01",
    "irsText": "If Form 2290, Part II, Line 9 \"Statement in Support of Suspension\" [StatementInSupportOfSuspension] is attached, then Vehicle Identification Numbers provided in the statement must not be present in Schedule 1(Form 2290), Part I.",
    "category": "Incorrect Data",
    "severity": "Reject",
    "fixable": true,
    "title": "VIN can't be in both the Line 9 statement and Schedule 1",
    "explanation": "A VIN listed as sold/transferred on Line 9 also appears on Schedule 1 - it can't be both.",
    "section": "PRIOR_YEAR",
    "howToFix": [
      "Open the return and go to the Prior year step.",
      "Review the suspended-vehicle VIN(s) you listed.",
      "Remove any duplicate, or correct a VIN that also appears on Schedule 1.",
      "Return to this filing, review it, and submit again."
    ]
  },
  {
    "code": "F2290-015-01",
    "codeSlug": "f2290-015-01",
    "irsText": "If Form 2290, \"Tax Computation\", Item \"Totals\" column (3) has a value, then Item \"Totals\" column (4) must have a value.",
    "category": "Missing Data",
    "severity": "Reject",
    "fixable": false,
    "title": "Tax computation table is incomplete",
    "explanation": "The \"Tax Computation\" table has a partial-period value without a matching total. This table is generated automatically."
  },
  {
    "code": "F2290-017",
    "codeSlug": "f2290-017",
    "irsText": "Schedule 1(Form 2290) Vehicle Identification Numbers provided must not contain duplicate values (across the form).",
    "category": "Incorrect Data",
    "severity": "Reject",
    "fixable": true,
    "title": "Duplicate VIN on this return",
    "explanation": "The same Vehicle Identification Number appears more than once on this return.",
    "section": "TRUCKS",
    "howToFix": [
      "Open the return and go to the Trucks step.",
      "Review the flagged VIN(s) and vehicle details.",
      "Correct or remove the affected vehicle.",
      "Return to this filing, review it, and submit again."
    ]
  },
  {
    "code": "F2290-018-01",
    "codeSlug": "f2290-018-01",
    "irsText": "Form 2290, Part I, Line 3, attachment \"Taxable Gross Weight Increase Worksheet\" [TGWIncreaseWorksheet], Line 4 \"Additional Tax Amount\" must equal Line 2 'NewTaxAmt' minus(-) Line 3 'PreviousTaxAmt' for each entry.",
    "category": "Math Error",
    "severity": "Reject",
    "fixable": false,
    "title": "Weight-increase worksheet total doesn't add up",
    "explanation": "The additional tax amount on the weight-increase worksheet doesn't equal the new tax minus the previous tax for one of the listed vehicles. This is a computed figure."
  },
  {
    "code": "F2290-019-01",
    "codeSlug": "f2290-019-01",
    "irsText": "If Form 2290, Part I, Line 3 or Line 2 has a non-zero value,then Form 2290, Part I, Line 4 must equal the sum of line 2 and line 3.",
    "category": "Math Error",
    "severity": "Reject",
    "fixable": false,
    "title": "Total tax doesn't match",
    "explanation": "Line 4 doesn't equal the sum of Line 2 and Line 3. This is a computed figure."
  },
  {
    "code": "F2290-024-01",
    "codeSlug": "f2290-024-01",
    "irsText": "If a filer consents to VIN Data Disclosure (if the element 'ConsentToDiscloseYesInd' in the Return Header is checked), and if the signature option \"PIN Number\" is selected in 'ConsentToVINDataDisclosureGrp' element in the Return Header, then \"PIN\" in 'ConsentToVINDataDisclosureGrp' must have a value.",
    "category": "Missing Data",
    "severity": "Reject",
    "fixable": false,
    "title": "VIN disclosure PIN is missing",
    "explanation": "A signature PIN is required for the VIN data disclosure consent option chosen, but wasn't provided."
  },
  {
    "code": "F2290-025-02",
    "codeSlug": "f2290-025-02",
    "irsText": "If a filer consents to VIN Data Disclosure (if the element 'ConsentToDiscloseYesInd' in the Return Header is checked), and if the signature option \"Binary Attachment VIN Disclosure Statement\" is selected in 'ConsentToVINDataDisclosureGrp' element in the Return Header, then a binary attachment with description \"VIN Data Disclosure Statement\" must be present.",
    "category": "Missing Document",
    "severity": "Reject",
    "fixable": false,
    "title": "VIN disclosure statement attachment is missing",
    "explanation": "A binary attachment for the VIN Data Disclosure Statement is required but wasn't included."
  },
  {
    "code": "F2290-026-01",
    "codeSlug": "f2290-026-01",
    "irsText": "Form 2290, Taxpayer TIN and tax period, Schedule 1 (Form 2290), the first 'VIN' and its 'VehicleCategoryCd' must not be the same as that of a previously accepted Form 2290 return, excluding a return where the Schedule 1 (Form 2290), the first 'VIN' and its 'VehicleCategoryCd' are blank.",
    "category": "Duplicate Condition",
    "severity": "Reject",
    "fixable": true,
    "title": "This VIN was already filed on an earlier accepted return",
    "explanation": "This VIN and vehicle category match a Form 2290 the IRS already accepted for this tax period - it can't be filed again on a new original return.",
    "section": "TRUCKS",
    "howToFix": [
      "Open the return and go to the Trucks step.",
      "Review the flagged VIN(s) and vehicle details.",
      "Correct or remove the affected vehicle.",
      "Return to this filing, review it, and submit again."
    ]
  },
  {
    "code": "F2290-027-01",
    "codeSlug": "f2290-027-01",
    "irsText": "If Form 2290, \"Final Return\" checkbox is not checked, then Schedule 1 (Form 2290) must contain at least one 'VIN'.",
    "category": "Missing Data",
    "severity": "Reject",
    "fixable": true,
    "title": "Final Return needs at least one vehicle, or shouldn't be checked",
    "explanation": "\"Final Return\" isn't checked, but no vehicle was listed on this return (Schedule 1 has no VIN).",
    "section": "FORM",
    "howToFix": [
      "Open the return and go to the Form step.",
      "If this is genuinely your last return, check Final Return - Trucks becomes optional. Otherwise leave it unchecked and add at least one vehicle on the Trucks step.",
      "Return to this filing, review it, and submit again."
    ]
  },
  {
    "code": "F2290-028-01",
    "codeSlug": "f2290-028-01",
    "irsText": "If Form 2290, \"Tax Computation\", Item \"Totals\" column (4) has a value, then \"Tax Computation\", Item \"Totals\" column (3) must have a value.",
    "category": "Missing Data",
    "severity": "Reject",
    "fixable": false,
    "title": "Tax computation table is incomplete",
    "explanation": "The \"Tax Computation\" table has a total without a matching partial-period value. This table is generated automatically."
  },
  {
    "code": "F2290-032-01",
    "codeSlug": "f2290-032-01",
    "irsText": "If form 2290, \"VIN Correction\" checkbox is checked, then Schedule 1 (Form 2290) must contain at least one 'VIN'.",
    "category": "Missing Data",
    "severity": "Reject",
    "fixable": true,
    "title": "VIN Correction needs at least one VIN",
    "explanation": "\"VIN Correction\" is checked, but no corrected VIN was listed.",
    "section": "VIN_CORRECTION",
    "howToFix": [
      "Open the return and go to the VIN correction step.",
      "Review the corrected VIN(s) and the explanation for the correction.",
      "Save.",
      "Return to this filing, review it, and submit again."
    ]
  },
  {
    "code": "F2290-033-01",
    "codeSlug": "f2290-033-01",
    "irsText": "If Form 2290, \"Amended Return\" checkbox is checked, then Schedule 1 (Form 2290) must contain at least one 'VIN'.",
    "category": "Missing Data",
    "severity": "Reject",
    "fixable": true,
    "title": "Amended Return needs at least one VIN",
    "explanation": "\"Amended Return\" is checked, but no vehicle (VIN) was listed on this return.",
    "section": "AMENDED_RETURN",
    "howToFix": [
      "Open the return and go to the Amended return step.",
      "Confirm the amendment reason and the weight-increase worksheet details.",
      "Save.",
      "Return to this filing, review it, and submit again."
    ]
  },
  {
    "code": "F2290-043-01",
    "codeSlug": "f2290-043-01",
    "irsText": "If Form 2290, Schedule 1, 'VehicleReportTaxItem' has at least one 'VIN', then 'VehicleCnt' must have a value.",
    "category": "Missing Data",
    "severity": "Reject",
    "fixable": true,
    "title": "Vehicle count is missing",
    "explanation": "A VIN was listed but the corresponding vehicle count field is blank.",
    "section": "TRUCKS",
    "howToFix": [
      "Open the return and go to the Trucks step.",
      "Review the flagged VIN(s) and vehicle details.",
      "Correct or remove the affected vehicle.",
      "Return to this filing, review it, and submit again."
    ]
  },
  {
    "code": "F2290-044-01",
    "codeSlug": "f2290-044-01",
    "irsText": "Form 2290, 'TotalVehicleCnt' must equal Schedule 1 (Form 2290), 'TaxableVehicleCnt'.",
    "category": "Data Mismatch",
    "severity": "Reject",
    "fixable": false,
    "title": "Vehicle count doesn't match Schedule 1",
    "explanation": "The total vehicle count on the form doesn't match Schedule 1's taxable vehicle count. This is a computed figure."
  },
  {
    "code": "F2290-045-01",
    "codeSlug": "f2290-045-01",
    "irsText": "Form 2290, Schedule 1, 'TotalSuspendedVehicleCnt' must equal the sum of Form 2290, 'TaxSuspendedNonLoggingVehCnt' and 'TaxSuspendedLoggingVehCnt'.",
    "category": "Data Mismatch",
    "severity": "Reject",
    "fixable": false,
    "title": "Suspended vehicle count doesn't match",
    "explanation": "Schedule 1's suspended-vehicle total doesn't match the sum of the two suspended-vehicle categories. This is a computed figure."
  },
  {
    "code": "F2290-046-01",
    "codeSlug": "f2290-046-01",
    "irsText": "Schedule 1 (Form 2290), 'TaxableVehicleCnt' must equal 'VehicleCnt' minus (-) 'TotalSuspendedVehicleCnt'.",
    "category": "Data Mismatch",
    "severity": "Reject",
    "fixable": false,
    "title": "Taxable vehicle count doesn't match",
    "explanation": "Schedule 1's taxable vehicle count doesn't equal total vehicles minus suspended vehicles. This is a computed figure."
  },
  {
    "code": "F2290-066",
    "codeSlug": "f2290-066",
    "irsText": "If Form 2290, VIN Correction checkbox [VINCorrectionInd] is checked then a \"VINCorrectionExplanationStmt\" [VINCorrectionExplanationStatement] must be present in the return.",
    "category": "Missing Data",
    "severity": "Reject",
    "fixable": true,
    "title": "VIN correction explanation is missing",
    "explanation": "\"VIN Correction\" is checked, but the required explanation statement for the correction wasn't included.",
    "section": "VIN_CORRECTION",
    "howToFix": [
      "Open the return and go to the VIN correction step.",
      "Review the corrected VIN(s) and the explanation for the correction.",
      "Save.",
      "Return to this filing, review it, and submit again."
    ]
  },
  {
    "code": "F2290-068-01",
    "codeSlug": "f2290-068-01",
    "irsText": "If Form 2290, 'BalanceDueAmt' has a non-zero value, then 'EFTPSPaymentInd' checkbox or 'CreditDebitCardPaymentInd' checkbox must be checked or an \"IRS Payment Record\" [IRSPayment] must be present in the return.",
    "category": "Missing Data",
    "severity": "Reject",
    "fixable": true,
    "title": "A balance due needs a payment method",
    "explanation": "There's a balance due to the IRS, but no payment method (EFTPS, card, or direct debit) was indicated.",
    "section": "PAY",
    "howToFix": [
      "Open the return and go to the Payment method step.",
      "Review the routing number, account number, and account type.",
      "Correct any field the IRS flagged.",
      "Return to this filing, review it, and submit again."
    ]
  },
  {
    "code": "F2290-077",
    "codeSlug": "f2290-077",
    "irsText": "The 'FirstUsedDt' in the Return Header must be greater than or equal to 202607 and less than or equal to 202706.",
    "category": "Incorrect Data",
    "severity": "Reject",
    "fixable": true,
    "title": "Month first used is out of range for this tax year",
    "explanation": "The \"month first used\" date on this return must fall within the July 2026-June 2027 tax period.",
    "section": "TRUCKS",
    "howToFix": [
      "Open the return and go to the Trucks step.",
      "Correct the month first used.",
      "Return to this filing, review it, and submit again."
    ]
  },
  {
    "code": "FPYMT-030-02",
    "codeSlug": "fpymt-030-02",
    "irsText": "'PaymentAmt' in the IRS Payment Record [IRSPayment] must not be greater than 'BalanceDueAmt' in Form 2290, but cannot be greater than 99999999.99.",
    "category": "Incorrect Data",
    "severity": "Reject",
    "fixable": true,
    "title": "Payment amount is invalid",
    "explanation": "The direct-debit payment amount can't be greater than the balance due, and can't exceed $99,999,999.99.",
    "section": "PAY",
    "howToFix": [
      "Open the return and go to the Payment method step.",
      "Review the routing number, account number, and account type.",
      "Correct any field the IRS flagged.",
      "Return to this filing, review it, and submit again."
    ]
  },
  {
    "code": "FPYMT-057-03",
    "codeSlug": "fpymt-057-03",
    "irsText": "'PaymentAmt' from each of the following payment structures must be less than or equal to 99,999,999: [IRSPayment] and [IRSESPayment] and [IRS965Payment] and [IRS1062Payment].",
    "category": "Incorrect Data",
    "severity": "Reject",
    "fixable": true,
    "title": "Payment amount is too large",
    "explanation": "The payment amount on this return exceeds the IRS's maximum of $99,999,999.",
    "section": "PAY",
    "howToFix": [
      "Open the return and go to the Payment method step.",
      "Review the routing number, account number, and account type.",
      "Correct any field the IRS flagged.",
      "Return to this filing, review it, and submit again."
    ]
  },
  {
    "code": "FPYMT-076-02",
    "codeSlug": "fpymt-076-02",
    "irsText": "The 'RequestedPaymentDt' in the IRS Payment Record [IRSPayment] must equal the \"Received Date\".",
    "category": "Incorrect Data",
    "severity": "Reject",
    "fixable": true,
    "title": "Payment date doesn't match the received date",
    "explanation": "The requested direct-debit payment date must equal the date the IRS receives the return - it's set automatically and can't be a date you pick.",
    "section": "PAY",
    "howToFix": [
      "Open the return and go to the Payment method step.",
      "Re-save your payment method so the payment date is set to today's received date.",
      "Return to this filing, review it, and submit again."
    ]
  },
  {
    "code": "R0000-003",
    "codeSlug": "r0000-003",
    "irsText": "The return version (attribute 'returnVersion' of the Return element) must be specified for each return in the return header.",
    "category": "Missing Data",
    "severity": "Reject and Stop",
    "fixable": false,
    "title": "Return version is missing",
    "explanation": "A required internal XML attribute (return version) wasn't set on this submission."
  },
  {
    "code": "R0000-004-01",
    "codeSlug": "r0000-004-01",
    "irsText": "'ReturnTypeCd' (specified in the Return Header) and the return version (specified by the 'returnVersion' attribute of the 'Return' element) of the return must match the return type and the version supported by the Modernized e-File system.",
    "category": "Data Mismatch",
    "severity": "Reject and Stop",
    "fixable": false,
    "title": "Return type/version mismatch",
    "explanation": "The return type and schema version don't match what the IRS e-file system currently supports."
  },
  {
    "code": "R0000-007-02",
    "codeSlug": "r0000-007-02",
    "irsText": "For US Addresses, the first five digits of 'ZipCd' of the Filer's address in the Return Header must be within the valid ranges of zip codes for the corresponding 'StateAbbreviationCd'. See Publication 4164.",
    "category": "Incorrect Data",
    "severity": "Reject",
    "fixable": true,
    "title": "ZIP code doesn't match the state",
    "explanation": "The ZIP code on the business address isn't within the valid range for the state selected.",
    "section": "BUSINESS",
    "howToFix": [
      "Open the return and go to the Business step.",
      "Check the address, ZIP, and phone number on file.",
      "Correct any field the IRS flagged.",
      "Save the business.",
      "Return to this filing, review it, and submit again."
    ]
  },
  {
    "code": "R0000-015-01",
    "codeSlug": "r0000-015-01",
    "irsText": "If 'PreparerFirmEIN' in the Return Header has a value, then it must not be \"999999999\".",
    "category": "Incorrect Data",
    "severity": "Reject",
    "fixable": false,
    "title": "Preparer firm EIN is a placeholder value",
    "explanation": "The preparer firm EIN can't be the reserved value \"999999999\"."
  },
  {
    "code": "R0000-018-01",
    "codeSlug": "r0000-018-01",
    "irsText": "The PTIN of the Preparer in the Return Header must not have the value \"P00000000\" or \"P99999999\".",
    "category": "Incorrect Data",
    "severity": "Reject",
    "fixable": false,
    "title": "Preparer PTIN is a placeholder value",
    "explanation": "The preparer's PTIN can't be one of the IRS's reserved placeholder values."
  },
  {
    "code": "R0000-019",
    "codeSlug": "r0000-019",
    "irsText": "The number of return documents (forms, schedules, and supporting documents) included in the return must be equal to the value of the 'documentCnt' attribute of the ReturnData.",
    "category": "Data Mismatch",
    "severity": "Reject",
    "fixable": false,
    "title": "Document count mismatch",
    "explanation": "The number of documents in the submission doesn't match the count declared in the transmission manifest - an internal packaging issue."
  },
  {
    "code": "R0000-021",
    "codeSlug": "r0000-021",
    "irsText": "The Employer Identification Number (EIN) of the Filer in the Return Header must not equal all nines.",
    "category": "Incorrect Data",
    "severity": "Reject",
    "fixable": true,
    "title": "EIN can't be all nines",
    "explanation": "The Employer Identification Number (EIN) on file for this business is invalid - the IRS never issues an EIN of all nines.",
    "section": "BUSINESS",
    "howToFix": [
      "Open the return and go to the Business step.",
      "Verify the EIN.",
      "Correct it if it was entered wrong.",
      "Save the business.",
      "Return to this filing, review it, and submit again."
    ]
  },
  {
    "code": "R0000-023-01",
    "codeSlug": "r0000-023-01",
    "irsText": "If the Filer has a US address in the Return Header and if the value of City is \"APO\" or \"FPO\", then the value of State must equal \"AA\", \"AE\" or \"AP\".",
    "category": "Incorrect Data",
    "severity": "Reject",
    "fixable": true,
    "title": "City/state mismatch for a military address",
    "explanation": "The city is \"APO\" or \"FPO\" but the state isn't one of the military state codes (AA, AE, AP).",
    "section": "BUSINESS",
    "howToFix": [
      "Open the return and go to the Business step.",
      "Check the address, ZIP, and phone number on file.",
      "Correct any field the IRS flagged.",
      "Save the business.",
      "Return to this filing, review it, and submit again."
    ]
  },
  {
    "code": "R0000-030-01",
    "codeSlug": "r0000-030-01",
    "irsText": "If 'PractitionerPINGrp' in the Return Header has a value, then 'EFIN' in 'PractitionerPINGrp' must be the same as 'EFIN' in 'OriginatorGrp'.",
    "category": "Data Mismatch",
    "severity": "Reject",
    "fixable": false,
    "title": "Practitioner EFIN mismatch",
    "explanation": "The practitioner's EFIN doesn't match the originator's EFIN in the transmission."
  },
  {
    "code": "R0000-031",
    "codeSlug": "r0000-031",
    "irsText": "Taxpayer PIN in the Return Header cannot equal all zeros.",
    "category": "Incorrect Data",
    "severity": "Reject",
    "fixable": false,
    "title": "Taxpayer PIN can't be all zeros",
    "explanation": "The signature PIN on the return is all zeros."
  },
  {
    "code": "R0000-032-01",
    "codeSlug": "r0000-032-01",
    "irsText": "Signature Option in the Return Header is a required field and must have either the value \"Binary Attachment 8453 Signature Document\" or \"PIN Number\".",
    "category": "Missing Data",
    "severity": "Reject",
    "fixable": false,
    "title": "Signature option is missing",
    "explanation": "A signature method (PIN or signed 8453 document) wasn't selected for this submission."
  },
  {
    "code": "R0000-034-01",
    "codeSlug": "r0000-034-01",
    "irsText": "If the Filer has a US address in the Return Header and State Abbreviation has the value \"AA\", \"AE\" or \"AP\" then the City must be \"APO\" OR \"FPO\".",
    "category": "Incorrect Data",
    "severity": "Reject",
    "fixable": true,
    "title": "City must be APO/FPO for a military state",
    "explanation": "The state is AA, AE, or AP, so the city must be \"APO\" or \"FPO\".",
    "section": "BUSINESS",
    "howToFix": [
      "Open the return and go to the Business step.",
      "Check the address, ZIP, and phone number on file.",
      "Correct any field the IRS flagged.",
      "Save the business.",
      "Return to this filing, review it, and submit again."
    ]
  },
  {
    "code": "R0000-046-01",
    "codeSlug": "r0000-046-01",
    "irsText": "For US Addresses, the fourth and fifth digit of the 'ZipCd' of the Filer's address in the Return Header cannot both be zeros (\"00\"), except when the 'ZipCd' is 00800, 20500, 34000, 00600, 96100, 96900.",
    "category": "Incorrect Data",
    "severity": "Reject",
    "fixable": true,
    "title": "ZIP code ends in 00",
    "explanation": "The last two digits of the ZIP code can't both be zero, other than a short list of IRS-recognized exceptions.",
    "section": "BUSINESS",
    "howToFix": [
      "Open the return and go to the Business step.",
      "Check the address, ZIP, and phone number on file.",
      "Correct any field the IRS flagged.",
      "Save the business.",
      "Return to this filing, review it, and submit again."
    ]
  },
  {
    "code": "R0000-051-01",
    "codeSlug": "r0000-051-01",
    "irsText": "'FederalSubmissionTypeCd' in the IRS Submission Manifest must match 'ReturnTypeCd' indicated in the Return Header.",
    "category": "Data Mismatch",
    "severity": "Reject and Stop",
    "fixable": false,
    "title": "Submission type mismatch",
    "explanation": "The transmission manifest's submission type doesn't match the return type - an internal packaging issue."
  },
  {
    "code": "R0000-052-01",
    "codeSlug": "r0000-052-01",
    "irsText": "'TaxYr' specified in the IRS Submission Manifest must match 'TaxYr' in the Return Header.",
    "category": "Data Mismatch",
    "severity": "Reject and Stop",
    "fixable": false,
    "title": "Tax year mismatch",
    "explanation": "The tax year in the transmission manifest doesn't match the tax year on the return - an internal packaging issue."
  },
  {
    "code": "R0000-054-01",
    "codeSlug": "r0000-054-01",
    "irsText": "The 'EFIN' in the IRS Submission Manifest must match 'EFIN' in the 'OriginatorGrp' in the Return Header.",
    "category": "Data Mismatch",
    "severity": "Reject and Stop",
    "fixable": false,
    "title": "EFIN mismatch",
    "explanation": "The EFIN in the transmission manifest doesn't match the return header - an internal packaging issue."
  },
  {
    "code": "R0000-055-02",
    "codeSlug": "r0000-055-02",
    "irsText": "If 'SignatureOptionCd' in the Return Header has the value \"Binary Attachment 8453 Signature Document\", then a binary attachment with description \"8453 Signature Document\" must be present in the return.",
    "category": "Missing Document",
    "severity": "Reject",
    "fixable": false,
    "title": "Signed 8453 document is missing",
    "explanation": "The signature option chosen requires a signed Form 8453 attachment that wasn't included."
  },
  {
    "code": "R0000-057-01",
    "codeSlug": "r0000-057-01",
    "irsText": "Every attached file (i.e. binary attachment) must be referenced by the XML document that represents it.",
    "category": "Missing Data",
    "severity": "Reject",
    "fixable": false,
    "title": "Attachment reference error",
    "explanation": "A binary attachment isn't referenced correctly by the XML - an internal packaging issue."
  },
  {
    "code": "R0000-058-01",
    "codeSlug": "r0000-058-01",
    "irsText": "An XML document that represents a binary attachment must have a valid reference to an attached file.",
    "category": "Missing Data",
    "severity": "Reject",
    "fixable": false,
    "title": "Attachment reference error",
    "explanation": "A binary attachment's reference doesn't point to a valid attached file - an internal packaging issue."
  },
  {
    "code": "R0000-060",
    "codeSlug": "r0000-060",
    "irsText": "First six digits in the Submission ID must match the EFIN in the Submission Manifest.",
    "category": "Incorrect Data",
    "severity": "Reject and Stop",
    "fixable": false,
    "title": "Submission ID/EFIN mismatch",
    "explanation": "The submission ID's EFIN prefix doesn't match the transmitter's EFIN - an internal transmission issue."
  },
  {
    "code": "R0000-067",
    "codeSlug": "r0000-067",
    "irsText": "The attached files (i.e. binary attachments) in a submission zip archive must have distinct names.",
    "category": "Incorrect Data",
    "severity": "Reject and Stop",
    "fixable": false,
    "title": "Duplicate attachment file names",
    "explanation": "Two or more binary attachments in this submission have the same file name - an internal packaging issue."
  },
  {
    "code": "R0000-069",
    "codeSlug": "r0000-069",
    "irsText": "Excise tax returns are not accepted on the EMS channel.",
    "category": "Unsupported",
    "severity": "Reject and Stop",
    "fixable": false,
    "title": "Unsupported filing channel",
    "explanation": "Excise tax returns can't be filed on this transmission channel."
  },
  {
    "code": "R0000-075-03",
    "codeSlug": "r0000-075-03",
    "irsText": "'RoutingTransitNum' (RTN) must conform to the banking industry RTN algorithm.",
    "category": "Incorrect Data",
    "severity": "Reject",
    "fixable": true,
    "title": "Routing number is invalid",
    "explanation": "The bank routing number doesn't pass the standard banking-industry checksum - it was likely mistyped.",
    "section": "PAY",
    "howToFix": [
      "Open the return and go to the Payment method step.",
      "Review the routing number, account number, and account type.",
      "Correct any field the IRS flagged.",
      "Return to this filing, review it, and submit again."
    ]
  },
  {
    "code": "R0000-079",
    "codeSlug": "r0000-079",
    "irsText": "The TIN present in the IRS Submission Manifest must match the EIN provided in the Return Header.",
    "category": "Data Mismatch",
    "severity": "Reject and Stop",
    "fixable": false,
    "title": "TIN mismatch",
    "explanation": "The TIN in the transmission manifest doesn't match the EIN in the return header - an internal packaging issue."
  },
  {
    "code": "R0000-084-01",
    "codeSlug": "r0000-084-01",
    "irsText": "If the signature option \"PIN Number\" is selected (the element \"SignatureOptionCd\" in the Return Header has a value of \"PIN Number\") and the PIN entered by option \"Taxpayer\" is selected (the element \"PINEnteredByCd\" in the Return Header has a value of \"Taxpayer\") and the Type option \"Online Filer\" is selected (the element \"OriginatorTypeCd\" in the Originator Section of the Return Header has a value of \"Online Filer\"), then the TaxpayerPIN field must have a value in the Return Header and this value cannot equal all zeros.",
    "category": "Incorrect Data",
    "severity": "Reject",
    "fixable": false,
    "title": "Taxpayer PIN is missing",
    "explanation": "A taxpayer-entered signature PIN is required for the signature option chosen, but wasn't provided."
  },
  {
    "code": "R0000-085-01",
    "codeSlug": "r0000-085-01",
    "irsText": "If the signature option \"PIN Number\" is selected (the element 'SignatureOptionCd' in the Return Header has a value of \"PIN Number\") and the PIN entered by option \"ERO\" is selected (the element 'PINEnteredByCd' in the Return Header has a value of \"ERO\"), then the 'PractitionerPINGrp' field must have a value in the Return Header and this value cannot equal all zeros.",
    "category": "Incorrect Data",
    "severity": "Reject",
    "fixable": false,
    "title": "Practitioner PIN is missing",
    "explanation": "A practitioner (ERO) signature PIN is required for the signature option chosen, but wasn't provided."
  },
  {
    "code": "R0000-120",
    "codeSlug": "r0000-120",
    "irsText": "The IRS Submission type that was filed is not being accepted by Modernized e-File (MeF) at this time. Please check the MeF web page under irs.gov for more information. The submission type filed was <type>.",
    "category": "Unsupported",
    "severity": "Reject and Stop",
    "fixable": false,
    "title": "Submission type not currently accepted",
    "explanation": "The IRS's Modernized e-File system isn't currently accepting this submission type."
  },
  {
    "code": "R0000-143",
    "codeSlug": "r0000-143",
    "irsText": "'TaxYr' in the IRS Submission Manifest must have a value.",
    "category": "Missing Data",
    "severity": "Reject and Stop",
    "fixable": false,
    "title": "Tax year is missing from the manifest",
    "explanation": "The transmission manifest doesn't declare a tax year - an internal packaging issue."
  },
  {
    "code": "R0000-148",
    "codeSlug": "r0000-148",
    "irsText": "'EIN' of the Filer in the Return Header must begin with \"00\" for submissions transmitted to the Assurance Testing System (ATS).",
    "category": "Incorrect Data",
    "severity": "Reject",
    "fixable": false,
    "title": "Test-system EIN format issue",
    "explanation": "Submissions to the IRS's Assurance Testing System (ATS) require an EIN starting with \"00\" - this only applies to test filings."
  },
  {
    "code": "R0000-180",
    "codeSlug": "r0000-180",
    "irsText": "'TaxYr' specified in the Submission Manifest must equal the year of the schema version ('YYYY' digits of the attribute 'returnVersion' of the Return) that is being used to file the return.",
    "category": "Incorrect Data",
    "severity": "Reject and Stop",
    "fixable": false,
    "title": "Tax year/schema version mismatch",
    "explanation": "The manifest's tax year doesn't match the schema version used to file the return - an internal packaging issue."
  },
  {
    "code": "R0000-192-01",
    "codeSlug": "r0000-192-01",
    "irsText": "Phone Number provided in the return must not be all zeros.",
    "category": "Incorrect Data",
    "severity": "Reject",
    "fixable": true,
    "title": "Phone number can't be all zeros",
    "explanation": "The phone number on file for this business is all zeros, which isn't a valid contact number.",
    "section": "BUSINESS",
    "howToFix": [
      "Open the return and go to the Business step.",
      "Enter a valid contact phone number.",
      "Save the business.",
      "Return to this filing, review it, and submit again."
    ]
  },
  {
    "code": "R0000-193-01",
    "codeSlug": "r0000-193-01",
    "irsText": "Bank Account Number provided in the return must not be all zeros.",
    "category": "Incorrect Data",
    "severity": "Reject",
    "fixable": true,
    "title": "Bank account number can't be all zeros",
    "explanation": "The account number entered for direct debit is all zeros, which isn't a valid account number.",
    "section": "PAY",
    "howToFix": [
      "Open the return and go to the Payment method step.",
      "Review the routing number, account number, and account type.",
      "Correct any field the IRS flagged.",
      "Return to this filing, review it, and submit again."
    ]
  },
  {
    "code": "R0000-194",
    "codeSlug": "r0000-194",
    "irsText": "Submission must not be a duplicate of a previously accepted submission.",
    "category": "Duplicate Condition",
    "severity": "Reject and Stop",
    "fixable": false,
    "title": "Duplicate submission",
    "explanation": "This exact submission was already accepted by the IRS previously."
  },
  {
    "code": "R0000-197-01",
    "codeSlug": "r0000-197-01",
    "irsText": "'AddressLine2Txt' in the Filer group of the Return Header must not have a value.",
    "category": "Incorrect Data",
    "severity": "Reject",
    "fixable": true,
    "title": "Address line 2 isn't allowed",
    "explanation": "The IRS e-file system doesn't accept a second address line for the filer's address in the return header.",
    "section": "BUSINESS",
    "howToFix": [
      "Open the return and go to the Business step.",
      "Remove anything entered in a second address line, folding it into the main address line if needed.",
      "Save the business.",
      "Return to this filing, review it, and submit again."
    ]
  },
  {
    "code": "R0000-221",
    "codeSlug": "r0000-221",
    "irsText": "The ETIN associated with the Business submission is not a participating transmitter. Please check the Modernized e-File (MeF) web page under irs.gov for more information on participation rules.",
    "category": "Unsupported",
    "severity": "Reject and Stop",
    "fixable": false,
    "title": "Transmitter not participating",
    "explanation": "The ETIN used for this submission isn't registered as a participating e-file transmitter."
  },
  {
    "code": "R0000-222",
    "codeSlug": "r0000-222",
    "irsText": "'PersonFirstNm' and 'PersonLastNm' in 'SigningOfficerGrp' in the Return Header must have a value.",
    "category": "Missing Data",
    "severity": "Alert",
    "fixable": false,
    "title": "Signing officer name is missing",
    "explanation": "The signing officer's first and last name are required in the return header but weren't provided."
  },
  {
    "code": "R0000-223",
    "codeSlug": "r0000-223",
    "irsText": "'SSN' in 'SigningOfficerGrp' in the Return Header must have a value.",
    "category": "Missing Data",
    "severity": "Alert",
    "fixable": false,
    "title": "Signing officer SSN is missing",
    "explanation": "The signing officer's SSN is required in the return header but wasn't provided."
  },
  {
    "code": "R0000-225",
    "codeSlug": "r0000-225",
    "irsText": "This submission contains a form or schedule that is not currently supported for electronic filing.",
    "category": "Unsupported",
    "severity": "Reject and Stop",
    "fixable": false,
    "title": "Unsupported form/schedule",
    "explanation": "This submission includes a form or schedule that isn't currently supported for e-file."
  },
  {
    "code": "R0000-232",
    "codeSlug": "r0000-232",
    "irsText": "'IRSResponsiblePrtyInfoCurrInd' in the Return Header is not marked \"Yes\". To update the Responsible Party on a future tax return filing, mark 'Form8822BAttachedInd' in the Return Header and a binary attachment with description \"Form8822-B\" must be present in the return. Form 8822-B, should only be attached to the return if the Responsible Party is being updated. Changes to Responsible Parties must be reported to the IRS within 60 days of a change. Please visit https://www.irs.gov/businesses/small-businesses-self-employed/responsible-parties-and-nominees for Responsible Party requirements.",
    "category": "Missing Document",
    "severity": "Alert",
    "fixable": false,
    "title": "Responsible-party information needs review",
    "explanation": "The IRS's responsible-party-currency confirmation isn't marked, or a required Form 8822-B attachment is missing - this only applies if your responsible party has changed."
  },
  {
    "code": "R0000-236",
    "codeSlug": "r0000-236",
    "irsText": "This submission contains a form or schedule which MeF is not accepting as a binary attachment. Please verify whether it is valid for your submission to include the form or schedule. If valid, complete the form or schedule in XML format and resubmit.",
    "category": "Unsupported",
    "severity": "Reject and Stop",
    "fixable": false,
    "title": "Unsupported binary attachment",
    "explanation": "This submission includes a form or schedule that MeF doesn't accept as a binary attachment."
  },
  {
    "code": "R0000-243",
    "codeSlug": "r0000-243",
    "irsText": "All tax forms included in submissions converted from paper must be present in both XML format and PDF format.",
    "category": "Incorrect Data",
    "severity": "Reject",
    "fixable": false,
    "title": "Paper-converted form mismatch",
    "explanation": "A form converted from paper must be present in both XML and PDF format."
  },
  {
    "code": "R0000-904-03",
    "codeSlug": "r0000-904-03",
    "irsText": "Software ID in the Return Header must have passed testing for the form family and 'TaxYr'.",
    "category": "Database Validation Error",
    "severity": "Reject and Stop",
    "fixable": false,
    "title": "Software not approved for this filing season",
    "explanation": "The e-file software ID hasn't passed IRS testing for this form and tax year."
  },
  {
    "code": "R0000-905-01",
    "codeSlug": "r0000-905-01",
    "irsText": "Electronic Filing Identification Number (EFIN) in the Return Header must be listed in the e-File database and in accepted status.",
    "category": "Database Validation Error",
    "severity": "Reject and Stop",
    "fixable": false,
    "title": "EFIN not in accepted status",
    "explanation": "The Electronic Filing Identification Number (EFIN) isn't listed as active in the IRS e-file database."
  },
  {
    "code": "R0000-906-03",
    "codeSlug": "r0000-906-03",
    "irsText": "Routing Transit Number (RTN) included in the return must be present in the e-File database.",
    "category": "Database Validation Error",
    "severity": "Reject",
    "fixable": true,
    "title": "Routing number isn't recognized",
    "explanation": "The bank routing number isn't found in the IRS's own database of valid routing numbers - double-check it against your bank.",
    "section": "PAY",
    "howToFix": [
      "Open the return and go to the Payment method step.",
      "Review the routing number, account number, and account type.",
      "Correct any field the IRS flagged.",
      "Return to this filing, review it, and submit again."
    ]
  },
  {
    "code": "R0000-922-01",
    "codeSlug": "r0000-922-01",
    "irsText": "Filer's EIN and Name Control in the Return Header must match data in the e-File database, unless \"Name Change\" or \"Name or Address Change\" checkbox is checked, if applicable.",
    "category": "Database Validation Error",
    "severity": "Reject",
    "fixable": true,
    "title": "EIN or business name doesn't match IRS records",
    "explanation": "The IRS could not match this business's EIN and name control (derived from the business name) to its own e-file database records, unless a name/address change box should have been checked.",
    "section": "BUSINESS",
    "howToFix": [
      "Open the return and go to the Business step.",
      "Verify the EIN is entered exactly as issued by the IRS.",
      "Verify the business name matches IRS records exactly (the legal name on your EIN confirmation letter).",
      "Save the business.",
      "Return to this filing, review it, and submit again."
    ]
  },
  {
    "code": "STATE-012",
    "codeSlug": "state-012",
    "irsText": "The State Submission category that was filed is not being accepted by Modernized e-File (MeF) at this time. Please check the MeF web page under irs.gov for more information. The submission category filed was <category>.",
    "category": "Unsupported",
    "severity": "Reject and Stop",
    "fixable": false,
    "title": "Submission category not currently accepted",
    "explanation": "The IRS's Modernized e-File system isn't currently accepting this submission category."
  },
  {
    "code": "T0000-013",
    "codeSlug": "t0000-013",
    "irsText": "The Message ID must be globally unique.",
    "category": "Incorrect Data",
    "severity": "Reject and Stop",
    "fixable": false,
    "title": "Duplicate message ID",
    "explanation": "The transmission's message ID has already been used - an internal transmission issue."
  },
  {
    "code": "T0000-014",
    "codeSlug": "t0000-014",
    "irsText": "The Submission ID must be globally unique.",
    "category": "Incorrect Data",
    "severity": "Reject and Stop",
    "fixable": false,
    "title": "Duplicate submission ID",
    "explanation": "The transmission's submission ID has already been used - an internal transmission issue."
  },
  {
    "code": "T0000-015",
    "codeSlug": "t0000-015",
    "irsText": "The ETIN in the Message ID (the first five digits) must match the ETIN provided with the request.",
    "category": "Incorrect Data",
    "severity": "Reject and Stop",
    "fixable": false,
    "title": "ETIN mismatch in message ID",
    "explanation": "The ETIN embedded in the message ID doesn't match the transmitter's ETIN - an internal transmission issue."
  },
  {
    "code": "T0000-016",
    "codeSlug": "t0000-016",
    "irsText": "The Message ID must be 20 positions in length and conform to the following format: 12 digits followed by 8 alphanumeric characters (only lower case alphabetic characters allowed).",
    "category": "Incorrect Data",
    "severity": "Reject and Stop",
    "fixable": false,
    "title": "Message ID format is invalid",
    "explanation": "The transmission's message ID doesn't follow the IRS's required format - an internal transmission issue."
  },
  {
    "code": "T0000-017",
    "codeSlug": "t0000-017",
    "irsText": "The Submission ID must be 20 characters in length.",
    "category": "Incorrect Data",
    "severity": "Reject and Stop",
    "fixable": false,
    "title": "Submission ID length is invalid",
    "explanation": "The transmission's submission ID isn't the required length - an internal transmission issue."
  },
  {
    "code": "X0000-005",
    "codeSlug": "x0000-005",
    "irsText": "The XML data has failed schema validation.",
    "category": "XML Error",
    "severity": "Reject and Stop",
    "fixable": false,
    "title": "XML failed schema validation",
    "explanation": "The submitted XML didn't pass the IRS's schema validation - an internal generation issue, not a data-entry mistake."
  },
  {
    "code": "X0000-008",
    "codeSlug": "x0000-008",
    "irsText": "The namespace declarations in the root element of the return ('Return' element) must be as follows:The default namespace shall be set to \"http://www.irs.gov/efile\" (xmlns= \"http://www.irs.gov/efile\").The namespace prefix \"efile\" shall be bound to the namespace \"http://www.irs.gov\" (xmlns:efile=\"http://www.irs.gov/efile\").",
    "category": "XML Error",
    "severity": "Reject and Stop",
    "fixable": false,
    "title": "XML namespace issue",
    "explanation": "The submitted XML's namespace declarations don't match the IRS's requirements - an internal generation issue."
  },
  {
    "code": "X0000-010",
    "codeSlug": "x0000-010",
    "irsText": "For each SubmissionID provided in the transmission manifest there must be a submission zip archive entry present in the Attachment Zip file whose name (without the \".zip\" extension) matches the SubmissionID.",
    "category": "Incorrect Data",
    "severity": "Reject and Stop",
    "fixable": false,
    "title": "Submission archive is malformed",
    "explanation": "The submission zip archive's structure doesn't match the transmission manifest - an internal packaging issue."
  },
  {
    "code": "X0000-011",
    "codeSlug": "x0000-011",
    "irsText": "All entries in the submission zip archive (zip file that is the submission) must begin with \"manifest/\" or \"/manifest/\" or \"xml/\" or \"/xml/\" or \"attachment/\" or \"/attachment/\" (all lower case characters).",
    "category": "Incorrect Data",
    "severity": "Reject and Stop",
    "fixable": false,
    "title": "Submission archive is malformed",
    "explanation": "One or more entries in the submission zip archive have an invalid path - an internal packaging issue."
  },
  {
    "code": "X0000-012",
    "codeSlug": "x0000-012",
    "irsText": "The name of a binary attachment file must be less than or equal to 64 bytes.",
    "category": "Incorrect Data",
    "severity": "Reject and Stop",
    "fixable": false,
    "title": "Attachment file name too long",
    "explanation": "A binary attachment's file name exceeds the IRS's 64-byte limit - an internal packaging issue."
  },
  {
    "code": "X0000-015",
    "codeSlug": "x0000-015",
    "irsText": "Each zip entry in the Attachment Zip file must end with \".zip\" extension.",
    "category": "Data Mismatch",
    "severity": "Reject and Stop",
    "fixable": false,
    "title": "Submission archive is malformed",
    "explanation": "A zip entry in the attachment archive doesn't end in \".zip\" - an internal packaging issue."
  },
  {
    "code": "X0000-018",
    "codeSlug": "x0000-018",
    "irsText": "A submission zip archive (zip file that is the submission) must contain exactly one entry that begins with \"manifest/\" or \"/manifest/\" and is followed by the file name \"manifest.xml\". The entry name must use lower case characters ('a' through 'z') only and the separator must be the forward slash character.",
    "category": "Incorrect Data",
    "severity": "Reject and Stop",
    "fixable": false,
    "title": "Submission archive is malformed",
    "explanation": "The submission zip archive is missing its required manifest.xml entry - an internal packaging issue."
  },
  {
    "code": "X0000-019",
    "codeSlug": "x0000-019",
    "irsText": "A submission zip archive (zip file that is the submission) must contain exactly one entry that consists of \"xml/\" or \"/xml/\" (all lower case characters) followed by a file name.",
    "category": "Incorrect Data",
    "severity": "Reject and Stop",
    "fixable": false,
    "title": "Submission archive is malformed",
    "explanation": "The submission zip archive is missing its required xml/ entry - an internal packaging issue."
  },
  {
    "code": "X0000-020",
    "codeSlug": "x0000-020",
    "irsText": "A submission zip archive (zip file that is the submission) may contain zero or more entries that begin with \"attachment/\" or \"/attachment/\" and each is followed by a file name. The entry name must use lower case characters ('a' through 'z') only and the separator must be the forward slash character.",
    "category": "Incorrect Data",
    "severity": "Reject and Stop",
    "fixable": false,
    "title": "Submission archive is malformed",
    "explanation": "An attachment entry in the submission zip archive is misnamed - an internal packaging issue."
  },
  {
    "code": "X0000-024",
    "codeSlug": "x0000-024",
    "irsText": "Unable to read a binary attachment in the Submission Zip Archive.",
    "category": "Incorrect Data",
    "severity": "Reject and Stop",
    "fixable": false,
    "title": "Couldn't read a binary attachment",
    "explanation": "The IRS couldn't read a binary attachment in the submission - an internal packaging issue."
  },
  {
    "code": "X0000-025",
    "codeSlug": "x0000-025",
    "irsText": "Unable to read XML data from the Submission Zip Archive.",
    "category": "Incorrect Data",
    "severity": "Reject and Stop",
    "fixable": false,
    "title": "Couldn't read the XML data",
    "explanation": "The IRS couldn't read the XML data in the submission - an internal packaging issue."
  },
  {
    "code": "X0000-027",
    "codeSlug": "x0000-027",
    "irsText": "Year (YYYY) in the SubmissionID must be processing year.",
    "category": "Incorrect Data",
    "severity": "Reject",
    "fixable": false,
    "title": "Submission ID year mismatch",
    "explanation": "The year embedded in the submission ID doesn't match the processing year - an internal transmission issue."
  },
  {
    "code": "X0000-029",
    "codeSlug": "x0000-029",
    "irsText": "A binary attachment submitted in the PDF format must begin with the file header \"%PDF-\".",
    "category": "Incorrect Data",
    "severity": "Reject and Stop",
    "fixable": false,
    "title": "PDF attachment is malformed",
    "explanation": "A PDF binary attachment doesn't start with a valid PDF file header - an internal packaging issue."
  },
  {
    "code": "X0000-030",
    "codeSlug": "x0000-030",
    "irsText": "The size and CRC32 checksum value must be provided for the submission XML file (i.e. xml data file that starts with \"xml/\" or \"/xml/\").",
    "category": "Incorrect Data",
    "severity": "Reject and Stop",
    "fixable": false,
    "title": "Submission archive is malformed",
    "explanation": "The submission's XML file is missing its required size/checksum values - an internal packaging issue."
  },
  {
    "code": "X0000-031",
    "codeSlug": "x0000-031",
    "irsText": "Zip Entry names must conform to the guidelines in Publication 4164.",
    "category": "Incorrect Data",
    "severity": "Reject and Stop",
    "fixable": false,
    "title": "Submission archive is malformed",
    "explanation": "A zip entry name doesn't conform to IRS packaging guidelines (Publication 4164) - an internal packaging issue."
  },
  {
    "code": "X0000-032",
    "codeSlug": "x0000-032",
    "irsText": "Unable to extract submission Zip Archive from the Message Attachment zip file.",
    "category": "Incorrect Data",
    "severity": "Reject and Stop",
    "fixable": false,
    "title": "Couldn't extract the submission archive",
    "explanation": "The IRS couldn't extract the submission zip archive - an internal packaging issue."
  },
  {
    "code": "X0000-033",
    "codeSlug": "x0000-033",
    "irsText": "Modernized e-File (MeF) accepts submissions only in the Unicode Transformation Format-8 (UTF-8) format.",
    "category": "Incorrect Data",
    "severity": "Reject and Stop",
    "fixable": false,
    "title": "Encoding issue",
    "explanation": "The submission wasn't encoded in UTF-8 as required."
  }
];

export const getRejectCode = (codeSlug) => REJECT_CODES.find((r) => r.codeSlug === codeSlug);

// One page per filer-fixable rule (/form-2290-reject-codes/<slug>). Kept as a
// plain list so generate-sitemap.mjs and check-internal-links.mjs can read it
// as text. Rules support has to handle are listed on the hub page only.
export const REJECT_CODE_PAGE_SLUGS = [
  "f2290-002-01",
  "f2290-003-01",
  "f2290-004-01",
  "f2290-005-01",
  "f2290-006",
  "f2290-008-01",
  "f2290-009-01",
  "f2290-010-01",
  "f2290-011-01",
  "f2290-012-01",
  "f2290-013-01",
  "f2290-017",
  "f2290-026-01",
  "f2290-027-01",
  "f2290-032-01",
  "f2290-033-01",
  "f2290-043-01",
  "f2290-066",
  "f2290-068-01",
  "f2290-077",
  "fpymt-030-02",
  "fpymt-057-03",
  "fpymt-076-02",
  "r0000-007-02",
  "r0000-021",
  "r0000-023-01",
  "r0000-034-01",
  "r0000-046-01",
  "r0000-075-03",
  "r0000-192-01",
  "r0000-193-01",
  "r0000-197-01",
  "r0000-906-03",
  "r0000-922-01",
];
